module.exports = __webpack_public_path__ + "static/media/DUET.60ab8efc.svg";